import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';
import './ContactUs.css'
import NavBar from '../Components/NavBar'
import Footer from '../Components/Footer'
import SeoMeta from '../Components/SeoMeta'

function ContactUs() {
  const location = useLocation();
  const canonicalUrl = `https://www.nimantrana.co.in${location.pathname || '/contact'}`;
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "url": canonicalUrl,
    "name": "Contact Nimantrana Hospitality",
    "description": "Connect with the Nimantrana hospitality team for reservations, events, and bespoke stay experiences.",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-7291999222",
      "contactType": "customer service",
      "areaServed": "IN",
      "availableLanguage": ["en"]
    }
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });


  const validateName = (name) => {
    const nameRegex = /^[a-zA-Z\s]{2,50}$/;
    return nameRegex.test(name.trim());
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[+]?[\d\s\-\(\)]{10,15}$/;
    return phoneRegex.test(phone.trim());
  };

 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));


    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }

    if (submitStatus.message) {
      setSubmitStatus({ type: '', message: '' });
    }
  };


  const validateForm = () => {
    const newErrors = {};

    
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    } else if (!validateName(formData.name)) {
      newErrors.name = 'Please enter a valid name (2-50 characters, letters and spaces only)';
    }

   
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://backend.nimantrana.co.in/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        setSubmitStatus({
          type: 'success',
          message: result.message
        });
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });
      } else {
        setSubmitStatus({
          type: 'error',
          message: result.message || 'Failed to send message. Please try again.'
        });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      setSubmitStatus({
        type: 'error',
        message: 'Failed to send message. Please check your connection and try again.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <SeoMeta
        title="Contact Nimantrana Hospitality | Book Your Stay"
        description="Reach the Nimantrana hospitality team for suite reservations, event inquiries, and personalized travel assistance."
        canonical={canonicalUrl}
        keywords="Nimantrana contact, hotel phone Noida, luxury stay enquiry, Nimantrana reservations"
        image="https://nimantrana-media.s3.ap-south-1.amazonaws.com/map.png"
        structuredData={contactSchema}
      />
      <NavBar />

      {/* Hero Section */}
      <div className="contact-hero">
        <div className="contact-hero-content">
          <h1>Contact Us</h1>
          <p>Get in Touch with Our Team.</p>
        </div>
      </div>

      <div className='contactUsMainContainer'>
        
        <div className='contactUsContentContainer'>
         
          {/* <div className='contactFormSection'>
            <h2>Let's Talk</h2>
            
            {submitStatus.message && (
              <div className={`submitStatus ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}
            
            <form className='contactForm' onSubmit={handleSubmit}>
              <div className='formGroup'>
                <label>Name *</label>
                <input 
                  type='text' 
                  name='name'
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder='Your full name'
                  className={`formInput ${errors.name ? 'error' : ''}`}
                  disabled={isSubmitting}
                />
                {errors.name && <span className='errorMessage'>{errors.name}</span>}
              </div>
              
              <div className='formGroup'>
                <label>Email Address *</label>
                <input 
                  type='text' 
                  name='email'
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="We'll get back to you here"
                  className={`formInput ${errors.email ? 'error' : ''}`}
                  disabled={isSubmitting}
                />
                {errors.email && <span className='errorMessage'>{errors.email}</span>}
              </div>
              
              <div className='formGroup'>
                <label>Phone Number *</label>
                <input 
                  type='tel' 
                  name='phone'
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder='Your contact number'
                  className={`formInput ${errors.phone ? 'error' : ''}`}
                  disabled={isSubmitting}
                />
                {errors.phone && <span className='errorMessage'>{errors.phone}</span>}
              </div>
              
              <div className='formGroup'>
                <label>Message (Optional)</label>
                <textarea 
                  name='message'
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder='Tell us how we can help'
                  className='formTextarea'
                  rows='4'
                  disabled={isSubmitting}
                />
              </div>
              
              <button 
                type='submit' 
                className='submitButton'
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div> */}
          
          <div className='contactInfoSection'>
            <div className='contactInfoCard'>
              <h3>Prefer a Direct Approach?</h3>
              
              <div className='contactMethod'>
                <div className='contactIcon'>
                    <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/callLogo.png' alt='Phone'></img>
                </div>
                <span>+91-7291999222</span>
              </div>
              
              <div className='contactMethod'>
                <div className='contactIcon'>
                    <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/mailLogo.png' alt='Email'></img>
                </div>
                <span>amenitytavern@gmail.com</span>
              </div>

              <div className='contactMethod'>
                <div className='contactIcon'>
                    <a href="https://www.instagram.com/nimantranasuites/" target="_blank" rel="noopener noreferrer" style={{color: 'inherit'}}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="#DCB15D"/>
                      </svg>
                    </a>
                </div>
                <span><a href="https://www.instagram.com/nimantranasuites/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>@nimantranasuites</a></span>
              </div>
              
              <div className='contactMethod'>
                <div className='contactIcon'>
                    <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/timeLogo.png' alt='Time'></img>
                </div>
                <span>Monday to Friday, 9 AM - 6 PM (GMT)</span>
              </div>
            </div>
            
            <div className='officeLocationCard'>
              <h3>Visit Our Hotel</h3>
              <div className='locationInfo'>
                <div className='contactIcon'>
                    <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/locationLogo.png' alt='Location'></img>
                </div>
                <span>Metro Station Road, Gardenia Gateway, Sector 75, Noida, Uttar Pradesh 201301</span>
              </div>
              
              <div className='mapContainer'>
                <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/map.png' alt='Office Location Map' className='mapImage' />
                <button className='directionsButton' onClick={() => {
                  window.open('https://www.google.com/maps/dir//Metro+Station+Road,+Gardenia+Gateway,+Sector+75,+Noida,+Uttar+Pradesh+201301/@28.5722958,77.2971807,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390cef61ccb34855:0x1df402215f6c310f!2m2!1d77.3795821!2d28.5723207?entry=ttu&g_ep=EgoyMDI1MDcyNy4wIKXMDSoASAFQAw%3D%3D')
                }}>
                  Get a Direction →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </div>
  )
}

export default ContactUs